// extracted by mini-css-extract-plugin
module.exports = {"tag":"footer_tag__1ae7C","menu":"footer_menu__wHAcc","donate":"footer_donate__1PzHn","support":"footer_support__1eLH9","developers":"footer_developers__2wMkL"};